import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import UserOne from '../../images/user/user-01.png';

import { RootState } from '../../store/store';
import { updateUserProfilePicture } from '../../store/slices/userProfile/userProfileSlice';

import { useUserProfile } from '../../hooks/useUserProfile';
import ImageCropField from '../../components/Shared/ImageCropField';

const ProfilePhoto = () => {
  const dispatch = useDispatch();

  const { handleUploadProfilePicture, handleDeleteProfilePicture } =
    useUserProfile();

  // =========================================================
  // 👤 Redux global (AuthInitializer ya cargó todo)
  // =========================================================

  const userProfile = useSelector(
    (state: RootState) => state.userProfile.userProfile
  );

  const userId = userProfile?.data?.id;

  const profileImage = userProfile?.profilePicture || UserOne;

  const [hasProfilePicture, setHasProfilePicture] = useState(
    !!userProfile?.profilePicture
  );

  // =========================================================
  // ✅ Guardar imagen recortada
  // =========================================================

  const handleCroppedUpload = async (croppedFile: File) => {
    if (!userId) return;

    try {
      await handleUploadProfilePicture(userId, croppedFile);

      const reader = new FileReader();
      reader.readAsDataURL(croppedFile);
      reader.onloadend = () => {
        const base64Image = reader.result as string;

        sessionStorage.setItem(`profileImage-${userId}`, base64Image);
        dispatch(updateUserProfilePicture(base64Image));

        setHasProfilePicture(true);
      };
    } catch (error) {
      console.error('Error al subir imagen:', error);
      dispatch(updateUserProfilePicture(UserOne));
      setHasProfilePicture(false);
    }
  };

  // =========================================================
  // 🗑️ Eliminar imagen
  // =========================================================

  const handleDeletePicture = async () => {
    if (!userId) return;

    try {
      await handleDeleteProfilePicture(userId);

      sessionStorage.removeItem(`profileImage-${userId}`);
      dispatch(updateUserProfilePicture(UserOne));

      setHasProfilePicture(false);
    } catch (error) {
      console.error('Error eliminando imagen:', error);
    }
  };

  // =========================================================
  // 🎨 UI
  // =========================================================

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-title-xsm font-semibold text-black dark:text-white">
          Foto de Perfil
        </h2>

        <p className="mt-1 text-sm text-body dark:text-bodydark">
          Sube, actualiza o elimina tu imagen de perfil.
        </p>
      </div>

      {/* Preview actual */}
      <div className="flex items-center gap-4">
        <div className="h-20 w-20 overflow-hidden rounded-full border border-stroke shadow-sm dark:border-strokedark">
          <img
            src={profileImage}
            alt="Foto de perfil"
            className="h-full w-full object-cover"
          />
        </div>
        <span className="text-sm text-body dark:text-bodydark">
          {hasProfilePicture ? 'Imagen actual' : 'Sin imagen'}
        </span>
      </div>

      {/* Recortador */}
      <ImageCropField
        label="Adjuntar archivo"
        helpText="Arrastra sobre la imagen para marcar el área circular que quieres como avatar."
        currentImage={
          userProfile?.profilePicture ? profileImage : undefined
        }
        aspect={1}
        round
        mimeType="image/jpeg"
        outputName="profile.jpg"
        onUpload={handleCroppedUpload}
        onDelete={handleDeletePicture}
      />
    </div>
  );
};

export default ProfilePhoto;
